import {Url} from '@/utils/url';

const cdnUrl = '//trek.scene7.com/is/image/TrekBicycleProducts/';
const thumbnailSize = {
  width: 160,
  height: 120,
};

const srcSetSizes = [
  {width: 480, height: 360},
  {width: 640, height: 480},
  {width: 768, height: 576},
  {width: 1024, height: 768},
  {width: 1200, height: 900},
  {width: 1440, height: 1080},
  {width: 1920, height: 1440},
];

const ProductImages = {
  /**
   * Get array of sizes for the given asset.
   * @param assetId
   * @param urlParams
   * @return {Array}
   */
  getSrcSet(assetId, urlParams = {}) {
    let srcset = [];
    srcSetSizes.forEach((size) => {
      const url = this.getAssetUrl(assetId, Object.assign({wid: size.width, hei: size.height}, urlParams));
      srcset.push(`${url} ${size.width}w`);
    });
    return srcset;
  },

  /**
   * Get formatted thumbnail URL.
   * @param assetId
   * @param urlParams
   * @return {*|string}
   */
  getThumbnailUrl(assetId, urlParams = {}) {
    return this.getAssetUrl(
      assetId,
      Object.assign(
        {
          wid: thumbnailSize.width,
          hei: thumbnailSize.height,
        },
        urlParams
      )
    );
  },

  /**
   * Get asset's URL for given asset ID and url parameters.
   * @param assetId
   * @param urlParams
   * @return {string}
   */
  getAssetUrl(assetId, urlParams = {}) {
    return `${cdnUrl}${assetId}?$responsive-pjpg$&cache=on,on&${Url.objectToQueryStringArray(urlParams).join('&')}`;
  },

  getAltTextBp(assetId) {
    if (!assetId) return;
    return assetId.replace('_', '-');
  },
};

export {ProductImages};
